module.exports = __webpack_public_path__ + "static/media/billing.34e73c8c.png";